export default {
  NONE: 'none',
  PUBLIC: 'public',
  VERSIONS: 'versions',
  PRIVATE: 'private'
}
